import { render } from "./testPage.vue?vue&type=template&id=0eacc5e9"
import script from "./testPage.vue?vue&type=script&lang=js"
export * from "./testPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__